import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useMemo } from 'react';

interface CreateUserHeaderProps {
  className?: string;
}

export function CreateUserHeader({ className }: CreateUserHeaderProps) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRTL = useMemo(() => i18n.language === 'ar', [i18n.language]);

  const handleCancel = () => {
    navigate('/users');
  };

  return (
    <div
      className={cn('bg-primary text-primary-foreground p-4 sm:p-6', className)}
    >
      <div className="max-w-6xl mx-auto">
        <div
          className={cn(
            'flex items-center gap-4',
            isRTL ? 'flex-row-reverse' : 'flex-row'
          )}
        >
          <Button
            variant="ghost"
            size="sm"
            onClick={handleCancel}
            className="text-primary-foreground hover:bg-primary-foreground/10"
          >
            <ArrowLeft className={cn('w-4 h-4', isRTL ? 'ml-2' : 'mr-2')} />
            {t('back')}
          </Button>
          <h1
            className={cn(
              'text-xl sm:text-2xl font-semibold',
              isRTL ? 'text-right' : 'text-left'
            )}
          >
            {t('users.create.title')}
          </h1>
        </div>
      </div>
    </div>
  );
}
